import React from 'react'

const ActuCardPlaceholder = () => {
    return (
        <div className='border border-1 border-secondary border-opacity-75 actu-card placeholder-wave'>
            <img alt="" className=' object-fit-cover actu-img placeholder col-12 bgcolor-primary' />
            <div className='p-2'>
                <h4 className='fs-6 col-12 placeholder bg-white'> </h4>
                <p className='fs-8s col-11 placeholder bg-white mb-1'></p>
                <p className='fs-8s col-10 placeholder bg-white mb-1'></p>
                <p className='fs-8s col-12 placeholder bg-white mb-1'></p>
                <div className=' d-flex flex-wrap justify-content-between align-items-center'>
                    <div className='px-2 py-3 bgcolor-primary placeholder col-4'></div>
                </div>
            </div>
        </div>
    )
}

export default ActuCardPlaceholder